import {
  progressTrendPointSchema,
  progressTrendsResponseSchema,
} from '@tempo-io/reporting-store-dto';
import type { z } from 'zod';

const trendDataPointSchema = progressTrendPointSchema.transform((point) => ({
  ...point,
  plannedCompleteRate: point.plannedCompleteRate ?? null,
  completedScope: point.completedScope ?? null,
  forecastedCompletedScope: point.forecastedCompletedScope ?? null,
  workScope: point.workScope ?? null,
  forecastedWorkScope: point.forecastedWorkScope ?? null,
}));

export type TrendDataPoint = z.infer<typeof trendDataPointSchema>;

export const trendsProgressSchema = progressTrendsResponseSchema.transform((response) => ({
  ...response,
  trendDataPoints: response.trendDataPoints.map((point) => trendDataPointSchema.parse(point)),
  targetDate: response.targetDate ?? null,
  completionRate: response.completionRate ?? null,
  scopeGrowthRate: response.scopeGrowthRate ?? null,
  ratesSinceDate: response.ratesSinceDate ?? null,
}));

export type TrendsProgress = z.infer<typeof trendsProgressSchema>;
